<!-- Coupons Modal -->
@if (visible() && couponMaster()) {
  <p-dialog
    [visible]="visible()"
    [resizable]="false"
    appendTo="body"
    [modal]="true"
    [breakpoints]="{ '1025px': '100vw', '400px': '100vw' }"
    [style]="{ width: '25vw' }"
    styleClass="no-header-modal no-overflow-content"
    (onHide)="CloseCouponPopup()"
  >
    <ng-template pTemplate="header" styleClass="hidden" />
    <ng-template pTemplate="content" styleClass="p-0">
      <!-- Header -->
      <div
        class="p-2 md:py-3 md:px-4 flex align-items-center justify-content-between relative border-bottom-1 border-300"
      >
        <h2 class="mb-0 text-sm">
          @if (coupons$ | async) {
            <strong class="mr-2">{{ (coupons$ | async).length }}</strong>
          }
          {{ 'ADMIN.COUPON.LBL_CODES' | translate }}
        </h2>
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="CloseCouponPopup()"
        ></div>
      </div>
      <!-- Header -->
      <!-- Header -->
      <div class="p-2 md:p-3 surface-50 relative border-bottom-1 border-300">
        <p-button
          (click)="DownloadCSV()"
          styleClass="p-button-outlined py-2 px-3 justify-content-center border-primary text-sm white-space-nowrap"
        >
          <img
            width="17"
            src="/assets/img/icons/microsoft-excel.svg"
            alt="Image"
          />
          <span class="ml-2">{{
            'ADMIN.COUPON.DOWNLOAD_CSV' | translate
          }}</span>
        </p-button>
      </div>
      <!-- Header -->
      <!-- Content -->
      @if ((coupons$ | async).length) {
        <div class="surface-50 text-sm py-2 border-bottom-1 border-300">
          <p-scrollPanel styleClass="w-full h-25rem text-sm">
            <!-- List Item -->
            @for (coupon of coupons$ | async; track coupon) {
              <div
                class="flex align-items-center justify-content-between p-3 border-bottom-1 border-300"
              >
                <div>{{ coupon.coupon_code }}</div>
                @if (coupon.coupon_current_redepmtion_count > 0) {
                  <span
                    class="inline-block border-1 border-primary text-primary p-1 border-round text-center uppercase surface-0 text-xs"
                    >{{ 'ADMIN.COUPON.USED' | translate }}</span
                  >
                } @else {
                  <div class="flex align-items-center">
                    <p-tag
                      [styleClass]="
                        coupon.coupon_code_status === 'Active'
                          ? 'p-mr-2 text-xxs font-normal uppercase white-space-nowrap cursor-pointer'
                          : 'p-mr-2 surface-600 text-xxs font-normal uppercase white-space-nowrap cursor-pointer'
                      "
                      severity="success"
                      >{{ coupon.coupon_code_status }}
                    </p-tag>
                    <p-button
                      icon="fa fa-angle-down"
                      [label]="'common.BUTTONS.BTN_ACTIONS' | translate"
                      iconPos="right"
                      styleClass="text-sm text-600 p-button-outlined p-button-secondary border-400 surface-0 p-2 ml-3"
                      (click)="action.toggle($event)"
                    />
                    <p-popover
                      #action
                      styleClass="overflow-hidden text-sm w-8rem -ml-5"
                    >
                      <ng-template #content>
                        <ul class="list-none -m-4 py-2 px-0 text-xs text-600">
                          @if (coupon.coupon_code_status !== 'Active') {
                            <li
                              (click)="
                                MarkActiveInactiveCouponLink(coupon, true)
                              "
                              class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                            >
                              <i class="fa fa-eye text-xs mr-2"></i
                              >{{ 'ADMIN.COUPON.MARK_ACTIVE' | translate }}
                            </li>
                          }
                          @if (coupon.coupon_code_status === 'Active') {
                            <li
                              (click)="
                                MarkActiveInactiveCouponLink(coupon, false)
                              "
                              class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                            >
                              <i class="fa fa-eye-slash text-xs mr-2"></i
                              >{{ 'ADMIN.COUPON.MARK_INACTIVE' | translate }}
                            </li>
                          }
                        </ul>
                      </ng-template>
                    </p-popover>
                  </div>
                }
                <!-- <span *ngIf="coupon && coupon.coupon_current_redepmtion_count > 0"
              class="inline-block border-1 border-primary text-primary p-1 border-round text-center uppercase surface-0 text-xs">{{'ADMIN.COUPON.USED' | translate}}
            </span> -->
                <!-- <ng-template #showActive>
            <i class="fa fa-times text-xl text-600 cursor-pointer ml-3"></i>
          </ng-template> -->
              </div>
            }
            <!-- List Item -->
          </p-scrollPanel>
        </div>
      }
      <!-- Content -->
      <!-- Modal Footer -->
      <div class="p-3 border-top-1 border-300 text-center">
        <p-button
          icon="fa fa-plus"
          [label]="'ADMIN.COUPON.LBL_GENERATE' | translate"
          styleClass="text-sm"
          (click)="openAddCoupon()"
        />
      </div>
      <!-- Modal Footer -->
    </ng-template>
  </p-dialog>
}
<!-- Coupons Modal -->

<!-- Generate Coupons Modal -->
@if (generateCouponsModal | async) {
  <p-dialog
    [visible]="generateCouponsModal"
    [resizable]="false"
    appendTo="body"
    [modal]="true"
    [breakpoints]="{ '1025px': '100vw', '354px': '100vw' }"
    [style]="{ width: '25vw' }"
    styleClass="no-header-modal no-overflow-content"
    (onHide)="closeAddCouponPopup()"
  >
    <ng-template pTemplate="header" styleClass="hidden" />
    <ng-template pTemplate="content" styleClass="p-0">
      <!-- Header -->
      <div
        class="p-2 md:py-3 md:px-4 flex align-items-center justify-content-between relative border-bottom-1 border-300"
      >
        <h2 class="mb-0 text-sm">
          {{ 'ADMIN.COUPON.GENERATE_MORE_COUPONS' | translate }}
        </h2>
        <div
          class="fa fa-times text-xl text-600 cursor-pointer"
          (click)="closeAddCouponPopup()"
        ></div>
      </div>
      <!-- Header -->
      <form [formGroup]="formGroup" (ngSubmit)="GenerateMoreCoupons()">
        <!-- Content -->
        <div class="p-2 md:p-3 surface-50 relative border-bottom-1 border-300">
          <label class="font-medium text-700 text-xs mb-2 block uppercase"
            >{{ 'ADMIN.COUPON.LBL_HOW_MANY' | translate }}
            <sup class="p-error">*</sup>
          </label>
          <!-- <p-inputNumber mode="decimal" inputStyleClass="w-full" styleClass="w-full" class="w-full text-sm"
        [maxlength]="4" [format]="false"  formControlName="max_redepmtion_count">
      </p-inputNumber> -->
          <app-shared-input-number
            [formGroup]="formGroup"
            [controlName]="maxRedemptionCountControl"
            [styleClass]="'w-full text-sm'"
            [conditionToFormat]="false"
            [mode]="'number'"
          />
          @if (
            maxRedemptionCountControl.touched &&
            maxRedemptionCountControl.invalid
          ) {
            <app-error-msg
              [errors]="maxRedemptionCountControl.errors"
              [fieldLabel]="'ADMIN.COUPON.MAX_REDEMPTION_COUNT' | translate"
            />
          }
        </div>
        <!-- Content -->
        <!-- Modal Footer -->
        <div
          class="p-3 border-top-1 border-300 flex align-items-center justify-content-between"
        >
          <div class="w-4">
            <button
              pButton
              (click)="closeAddCouponPopup()"
              [label]="'ADMIN.COUPON.BUTTON_CANCEL' | translate"
              type="button"
              class="p-button-link text-sm"
            ></button>
          </div>
          <div class="w-8 text-right">
            <button
              pButton
              type="submit"
              [disabled]="!formGroup.valid"
              [loading]="loadingBtn"
              [label]="'ADMIN.COUPON.BTN_GENERATE' | translate"
              class="text-sm"
            ></button>
          </div>
        </div>
        <!-- Modal Footer -->
      </form>
    </ng-template>
  </p-dialog>
}
<!-- Generate Coupons Modal -->
